import { ChevronLeft } from '@styled-icons/bootstrap';
import { LanguageSwitch } from 'components/Shared';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
const Container = styled.div `
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 16px;
  z-index: 5;

  > * {
    pointer-events: all;
  }
`;
const SeedtraceLogo = styled.img `
  width: 120px;
`;
const MenuOuter = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  height: 40px;
  width: 100%;
  z-index: 12;
  pointer-events: none;
  box-shadow: ${({ isTransparent, theme }) => isTransparent ? 'none' : theme.shadows[0]};
  transition: all 0.2s ease;
`;
const BackButton = styled.button `
  background: transparent;
  font-size: 12px;
  border: none;
  display: flex;
  align-items: center;
  grid-gap: 5px;
  font-weight: 500;
  cursor: pointer;
  color: #000;
`;
const Header = ({ onNavigateBack, isHeaderTransparent, company, }) => {
    const { t } = useTranslation();
    return (React.createElement(MenuOuter, { isTransparent: isHeaderTransparent },
        React.createElement(Container, null,
            onNavigateBack ? (React.createElement(BackButton, { onClick: onNavigateBack, "data-cy": "header-back-button" },
                React.createElement(ChevronLeft, { size: 13 }),
                t('back-button'))) : (React.createElement(SeedtraceLogo, { src: "/seedtrace_logo_wordmark_black.svg", alt: "seedtrace_logo" })),
            React.createElement("div", null, company && React.createElement(LanguageSwitch, null)))));
};
export default Header;
